export default __webpack_public_path__ + "static/media/logo-telemedicine-3.33fb1096.svg";